import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_ACTION_USER } from 'reactApp/appHelpers/configHelpers';

export const autumnPromo: boolean = IS_ACTION_USER && getFeature('autumn-promo');
